
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import im1 from './images/qlxj/1.png';
import im2 from './images/qlxj/2.png';
import im3 from './images/qlxj/3.png';
import im4 from './images/qlxj/4.png';
import im5 from './images/qlxj/5.png';
import im6 from './images/qlxj/6.png';
import im7 from './images/qlxj/7.png';
import im8 from './images/qlxj/8.png';
import im9 from './images/qlxj/9.png';
import im10 from './images/qlxj/10.png';
import im11 from './images/qlxj/11.png';
import im12 from './images/qlxj/12.png';
import im13 from './images/qlxj/13.png';
import im14 from './images/qlxj/14.png';
import im15 from './images/qlxj/15.png';
import im16 from './images/qlxj/16.png';
import im17 from './images/qlxj/17.png';
import im18 from './images/qlxj/18.png';
import im19 from './images/qlxj/19.png';
import im20 from './images/qlxj/20.png';
import im21 from './images/qlxj/21.png';
import im22 from './images/qlxj/22.png';
import im23 from './images/qlxj/23.png';
import im24 from './images/qlxj/24.png';
import im25 from './images/qlxj/25.png';
export default {
data(){
return{
demo01_index:0,
demo01_list:[{
url: 'javascript:',
img: im1,
}, {
url: 'javascript:',
img: im2,
}, {
url: 'javascript:',
img: im3,
},{
url: 'javascript:',
img: im4,
}, {
url: 'javascript:',
img: im5,
}, {
url: 'javascript:',
img: im6,
},{
url: 'javascript:',
img: im7,
}, {
url: 'javascript:',
img: im8,
}, {
url: 'javascript:',
img: im9,
}, {
url: 'javascript:',
img: im10,
},{
url: 'javascript:',
img: im11,
}, {
url: 'javascript:',
img: im12,
}, {
url: 'javascript:',
img: im13,
},{
url: 'javascript:',
img: im14,
}, {
url: 'javascript:',
img: im15,
}, {
url: 'javascript:',
img: im16,
},{
url: 'javascript:',
img: im17,
}, {
url: 'javascript:',
img: im18,
}, {
url: 'javascript:',
img: im19,
}, {
url: 'javascript:',
img: im20,
},{
url: 'javascript:',
img: im21,
}, {
url: 'javascript:',
img: im22,
}, {
url: 'javascript:',
img: im23,
},{
url: 'javascript:',
img: im24,
}, {
url: 'javascript:',
img: im25,
},
],
list:[],
}
},
directives: {
TransferDom
},
components: {
XHeader,Swiper,Previewer
},
methods: {
show (index) {
this.$refs.previewer.show(index);
console.log(index,3432423)
},
},
mounted(){
for(let i =0;i<this.demo01_list.length;i++){
this.list.push({ w: 800, h: 400,msrc:this.demo01_list[i].img,src:this.demo01_list[i].img})
}
console.log(this.list)
}
}



// WEBPACK FOOTER //
// ./src/project/articleProject/qlxj.vue